<template>
  <form class="space-y-4" novalidate @submit.prevent="submit">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div class="md:col-span-3">
        <label :for="idPrefix + '-title'" class="block text-sm font-medium text-gray-700">{{ $t('projects.quiz_title_label') }}</label>
        <input :id="idPrefix + '-title'" v-model="form.title" type="text" required
               class="mt-1 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:border-blue-300 sm:text-sm">
      </div>
      <div>
        <label :for="idPrefix + '-pass'" class="block text-sm font-medium text-gray-700">{{ $t('projects.quiz_pass_percentage_label') }}</label>
        <input :id="idPrefix + '-pass'" v-model.number="form.pass_percentage" type="number" min="0" max="100" step="1" required
               class="mt-1 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-300 sm:text-sm">
      </div>
      <div>
        <label :for="idPrefix + '-attempts'" class="block text-sm font-medium text-gray-700">{{ $t('projects.quiz_max_attempts_label') }}</label>
        <input :id="idPrefix + '-attempts'" v-model="maxAttemptsInput" type="number" min="1" step="1"
               :placeholder="$t('projects.quiz_unlimited')" :aria-describedby="idPrefix + '-attempts-help'"
               class="mt-1 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:border-blue-300 sm:text-sm">
        <p :id="idPrefix + '-attempts-help'" class="mt-1 text-xs text-gray-500">{{ $t('projects.quiz_max_attempts_help') }}</p>
      </div>
      <div class="flex flex-col justify-center gap-2">
        <label class="inline-flex items-center text-sm text-gray-700">
          <input v-model="form.required_to_progress" type="checkbox" class="h-4 w-4 text-bpblue border-gray-300 rounded focus:ring-bpblue">
          <span class="ml-2">{{ $t('projects.quiz_required_to_progress') }}</span>
        </label>
        <label class="inline-flex items-center text-sm text-gray-700">
          <input v-model="form.shuffle" type="checkbox" class="h-4 w-4 text-bpblue border-gray-300 rounded focus:ring-bpblue">
          <span class="ml-2">{{ $t('projects.quiz_shuffle') }}</span>
        </label>
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-end gap-3">
      <p v-if="error" class="mr-auto text-sm text-red-600" role="alert">{{ $t(error) }}</p>
      <button type="submit" :disabled="saving || !isDirty"
              class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-100 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        <font-awesome-icon v-if="saving" class="mr-2 h-4 w-4 animate-spin" icon="spinner"/>
        {{ $t('projects.quiz_save_settings') }}
      </button>
    </div>
  </form>
</template>

<script>
import {validateSettings} from "@/views/projects/ProjectEdit/Blocks/Quiz/quizValidation";

const SETTINGS_FIELDS = ['title', 'pass_percentage', 'max_attempts', 'required_to_progress', 'shuffle']
const pickSettings = (quiz) => Object.fromEntries(SETTINGS_FIELDS.map((field) => [field, quiz[field]]))

// Ajustes del quiz: título, nota mínima, intentos y comportamiento (LMS-090).
export default {
  name: "QuizSettingsForm",
  props: {
    quiz: {
      type: Object,
      required: true
    },
    idPrefix: {
      type: String,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['save'],
  data() {
    return {
      form: pickSettings(this.quiz),
      error: null,
    }
  },
  computed: {
    isDirty() {
      return JSON.stringify(this.form) !== JSON.stringify(pickSettings(this.quiz))
    },
    // Campo vacío = intentos ilimitados (null en la API).
    maxAttemptsInput: {
      get() {
        return this.form.max_attempts ?? ''
      },
      set(value) {
        this.form.max_attempts = value === '' || value === null ? null : Number(value)
      }
    }
  },
  watch: {
    quiz() {
      this.form = pickSettings(this.quiz)
      this.error = null
    }
  },
  methods: {
    submit() {
      this.error = validateSettings(this.form)
      if (this.error) return

      this.$emit('save', {...this.form, title: this.form.title.trim()})
    }
  }
}
</script>
